import Immutable from 'seamless-immutable'
import { APP_HIDE_LOADING, APP_SHOW_LOADING } from './actionTypes'

// TODO: Set initial state up different depending on dev / production

// Production domain https://elm.govdocs.com

const initialState = Immutable({
  apiBasePath: API_BASE_PATH,
  loading: false,
  title: 'GovDocs'
})

export default function State (state = initialState, action) {
  switch (action.type) {
    case APP_HIDE_LOADING:
      state = Immutable.set(state, 'loading', false)
      state = Immutable.set(state, 'loadingCount', 0)
      break

    case APP_SHOW_LOADING:
      state = Immutable.set(state, 'loading', true)
      state = Immutable.set(state, 'loadingCount', action.payload.count)
      break

    default:
      break
  }

  return state
}
